/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ResolvedRuleSource = {
    DEFAULT: 'DEFAULT',
    DERIVED: 'DERIVED',
    RULE_SET: 'RULE_SET',
    CUSTOM: 'CUSTOM'
} as const;
export type ResolvedRuleSource = typeof ResolvedRuleSource[keyof typeof ResolvedRuleSource];


export function instanceOfResolvedRuleSource(value: any): boolean {
    for (const key in ResolvedRuleSource) {
        if (Object.prototype.hasOwnProperty.call(ResolvedRuleSource, key)) {
            if (ResolvedRuleSource[key as keyof typeof ResolvedRuleSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ResolvedRuleSourceFromJSON(json: any): ResolvedRuleSource {
    return ResolvedRuleSourceFromJSONTyped(json, false);
}

export function ResolvedRuleSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolvedRuleSource {
    return json as ResolvedRuleSource;
}

export function ResolvedRuleSourceToJSON(value?: ResolvedRuleSource | null): any {
    return value as any;
}

export function ResolvedRuleSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): ResolvedRuleSource {
    return value as ResolvedRuleSource;
}

